import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const ClearIcon: FC<IconProps> = memo(
  ({ fill = '#000', size, width, height }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(32);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        fill="none"
        width={width ?? size}
        height={height ?? size}
      >
        <Path
          d="M512 32C246.4 32 32 246.4 32 512s214.4 480 480 480 480-214.4 480-480S777.6 32 512 32z m140.8 579.2c12.8 12.8 12.8 32 0 41.6-12.8 12.8-32 12.8-41.6 0L512 553.6l-99.2 99.2c-12.8 12.8-32 12.8-41.6 0s-12.8-32 0-41.6l99.2-99.2-99.2-99.2c-12.8-12.8-12.8-32 0-41.6 12.8-12.8 32-12.8 41.6 0l99.2 99.2 99.2-99.2c12.8-12.8 32-12.8 41.6 0 12.8 12.8 12.8 32 0 41.6L553.6 512l99.2 99.2z"
          fill={fill}
        />
      </Svg>
    );
  },
);
